<template>
  <div class="main-container" id="newdetail">
    <div class="newcontainer">
      <div class="detali">
        <div v-html="htmlT" class="newsbox"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { newsDetail_url } from "../request/api";
export default {
  data() {
    return {
      htmlT: "",
    };
  },
  methods: {},
  mounted() {
    newsDetail_url({ id: this.$route.query.id }).then((res) => {
      this.htmlT =res.data.data.content;
    });
  },
};
</script>
<style lang="less">
#newdetail {
  .newcontainer {
    width: 100%;
    // min-height: calc(100vh - 300px);
    .detali {
      width: 65%;
      padding-top: 3%;
      margin: 0 auto;
    }
  }
}

@media (max-width: 991px) {
  #newdetail {
    .newcontainer {
      width: 100%;
      background: unset;
      .detali {
        width: 90%;
        padding-top: 3%;
        margin: 0 auto;
        .newsbox {
          width: 100%;
          p {
          }
          h1{
            font-size: 0.36rem!important;
            line-height: unset;
          }
          img {
            width: 100% !important;
            height: unset !important;
          }
        }
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/view/NewDetail.vue